export const getWithdrawSteps = (t: (key: string) => string): string[] => [
  t("withdrawSteps.step1"),
  t("withdrawSteps.step2"),
  t("withdrawSteps.step3"),
  t("withdrawSteps.step4"),
];
